'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonClickDispatch = buttonClickDispatch;
exports.linkClickDispatch = linkClickDispatch;
exports.interactionEventDispatch = interactionEventDispatch;

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * fetches requests
 * @returns {thunk} puts returned requests in state
 */
function buttonClickDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackButtonClick(payload));
  };
}

function linkClickDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackLinkClick(payload));
  };
}

function interactionEventDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackInteractionEvent(payload));
  };
};


//////////////////
// WEBPACK FOOTER
// ./lib/analytics/modules/AnalyticsModule.js
// module id = 63
// module chunks = 0